import { useMemo } from 'react';

import {
  DEFAULT_GRID_ROWS,
  REPORT_PAGE_WIDTH,
  REPORT_THEME,
} from '../components/PageConfigProvider/constants';

type GridLayoutOverflow = 'auto' | 'visible';

export type UseGridLayoutArgs = {
  isReport: boolean;
  gridRows: number;
  gridColumns: number;
};

export type GridLayoutStyles = {
  padding?: string;
  paddingLeft?: string;
  paddingRight?: string;
  height: string;
  overflow: GridLayoutOverflow;
  gridTemplateRows: string;
  gridTemplateColumns: string;
};

export type GridLayoutResult = {
  styles: GridLayoutStyles;
  contentHeight: string;
  containerProps: {
    overflow: GridLayoutOverflow;
  };
};

export const useGridLayout = ({
  isReport,
  gridRows,
  gridColumns,
}: UseGridLayoutArgs): GridLayoutResult => {
  return useMemo(() => {
    const heightPct = `${(gridRows / DEFAULT_GRID_ROWS) * 100}%`;
    const overflow: GridLayoutOverflow = isReport ? 'visible' : 'auto';

    const halfWidth = REPORT_PAGE_WIDTH / 2;
    const reportCenterPadding = `max(calc(50% - ${halfWidth}px), ${REPORT_THEME.margins.minCenterMargin}px)`;

    const styles: GridLayoutStyles = {
      ...(isReport
        ? {
            paddingLeft: reportCenterPadding,
            paddingRight: reportCenterPadding,
          }
        : { padding: '1rem' }),
      height: isReport ? heightPct : '100%',
      overflow,
      gridTemplateRows: `repeat(${gridRows}, 1fr)`,
      gridTemplateColumns: `repeat(${gridColumns}, 1fr)`,
    };

    return {
      styles,
      contentHeight: heightPct,
      containerProps: { overflow },
    };
  }, [gridColumns, gridRows, isReport]);
};
